import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import { Grid, MenuItem, Select, Typography, FormControl, FormLabel } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import serviciosSolicitudes from "utils/serviciosSolicitudes";
import DatePicker, { registerLocale } from "react-datepicker";
import moment from "moment";
import es from 'date-fns/locale/es';
import { format } from "prettier";
// import { FormControl, FormLabel } from "react-bootstrap";
registerLocale('es', es)

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    height: 140,
    width: 100,
  },
  control: {
    padding: theme.spacing(2),
  },
  letraAzul:{
    color: '#1C6BB0'
  },
}));

export default function FormularioTarea(props) {
  const {register, errors, defaultItem, ctl, watch, setValue, id, setMensaje, getValues, setCambio, datoS,} = props;
  const classes = useStyles();
  setValue('idsolicitud', datoS.idsolicitud);

  const options = [
    { idestatus: 9, label: "Activo" },
    { idestatus: 10, label: "Inactivo" },
  ];
  const [inputValue, setInputValue] = React.useState("");
  const [cargando, setCargando] = useState(false);

  const handleChangePrioridad = (event, value) => {
    // console.log(value);
    setValue("prioridad", value);
  };
  return (
    <Grid container className={classes.root} spacing={2}>
      <Grid item lg={12} xs={12}>
        <TextField
          // defaultValue={defaultItem.titulo}
          id="outlined-error-helper-text"
          label="TÍTULO"
          variant="outlined"
          fullWidth
          name="titulo"
          // disabled={defaultItem.titulo?true:false}
          inputRef={register({
            required: {
              value: true,
              message: "TÍTULO ES REQUERIDO",
            },
            minLength: {
              value: 1,
              message: "MÍNIMO 1 CARÁCTERES",
            },
          })}
          error={Boolean(errors.titulo)}
          helperText={errors.titulo}
        />
      </Grid>

      <Grid item md={12} xs={12}>
        <Autocomplete
          options={ctl.prioridad}
          getOptionLabel={(option) => option.nprioridad}
          getOptionSelected={(option, value) =>
            option.idprioridad == value.idprioridad
          }
          onChange={handleChangePrioridad}
          value={watch("prioridad")}
          size="small"
          renderInput={(params) => (
            <TextField
              label="PRIORIDAD"
              variant="outlined"
              {...params}
              error={Boolean(errors.prioridad)}
              helperText={errors.prioridad}
            />
          )}
        />
      </Grid>
      <Grid item lg={12} xs={12}>
        <TextField
          multiline
          rows={3}
          // defaultValue={defaultItem.descripcion}
          id="outlined-error-helper-text"
          label="DESCRIPCIÓN"
          variant="outlined"
          fullWidth
          name="descripcion"
          inputRef={register({
            required: {
              value: true,
              message: "DESCRIPCIÓN ES REQUERIDO",
            },
            minLength: {
              value: 1,
              message: "MÍNIMO 1 CARÁCTERES",
            },
          })}
          error={Boolean(errors.descripcion)}
          helperText={errors.descripcion}
        />
      </Grid>
    </Grid>
  );
}
